



















































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import DxButton from 'devextreme-vue/button';
import BaseMixin from '@/components/mixins/base';
import DxList from 'devextreme-vue/list';
import { DxPopup, DxPosition, DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';

import VueApexCharts from 'vue-apexcharts';

import { Panel } from '@/components';

import { DxLoadPanel } from 'devextreme-vue/load-panel';

import ShareChartPanel from './share-chart-panel.vue';
import ShareDashboardOrChartPanel from './share-dashboard-or-chart-panel.vue';

import AddEditDashboard from './add-edit-dashboard.vue';

import ChartsListPanel from './charts-list-panel.vue';

import DashboardGrid from './dashboard-grid.vue';

import { configuration } from '@/configuration';
import AddChartIcon from '@/assets/insights-new.svg';
import {
  apiService, customerService
} from '@/container';
import { IDashboard } from './types';
import { getEmptyDashboard } from './utils';
import { DxTooltip } from 'devextreme-vue/tooltip';


@Component({
  components: {
    AddEditDashboard,
    'apexchart': VueApexCharts,
    ChartsListPanel,
    DashboardGrid,
    DxButton,
    DxList, DxLoadPanel,
    DxPopup, DxPosition, DxTooltip,
    DxScrollView,
    DxToolbarItem,
    Panel,
    ShareChartPanel, ShareDashboardOrChartPanel
  }
})
export default class Dashboard extends BaseMixin {
  @Prop({ type: Boolean, default: false }) readonly!: boolean;

  addChartIcon = AddChartIcon;

  showChartSharingPanel = false;
  showDashboardSharingPanel = false;
  showChartsListPanel = false;
  showDashboardSelectionPanel = false;

  internalShowDashboardAdd = false;
  internalShowDashboardEdit = false;
  internalShowGrid = true;


  isLoadingDashboard = true;
  isLoadingDashboardsList = true;

  availableDashboards: IDashboard[] = [];
  availableCompanies: ICompanyItem[] = [];
  sharedWithMeDashboards: IDashboard[] = [];
  sharedWithMyCompanyDashboards: IDashboard[] = [];


  currentDashboardId: string | null = null;
  dashboardToShareId: string | null = null;
  dashboardLastSelectedId: string | null = null;

  currentDasboardShared = false;

  idChartToShare: string | null = null;
  showTooltip = false;
  tooltipTarget: string | null = null;
  tooltipText: string | null = null

  edgeElement = false;

  // eslint-disable-next-line no-empty-function
  reloadDashboard: () => Promise<void> = async () => { };

  async created() {
    if (_.isString(this.$route.query.idDashboard) && this.$route.query.idDashboard.trim() !== '')
      this.currentDashboardId = this.$route.query.idDashboard.toString();
    if (customerService.isCustomerSet)
      await this.loadDashboardList();
  }

  get isDashoboardSelected() {
    return !_.isNil(this.currentDashboardId);
  }

  get idCustomer() {
    return customerService.getCustomer();
  }
  get isSelectingCustomer() {
    return !customerService.isCustomerSet;
  }

  get currentDashboard(): IDashboard {
    if ((!this.areDashboardsAvailable && !this.areSharedDashboardsAvailable)|| _.isNil(this.currentDashboardId))
      return getEmptyDashboard();
    const r = this.availableDashboards.find(d => d.id === this.currentDashboardId);
    const s = this.sharedWithMeDashboards.find(d => d.id === this.currentDashboardId);
    if (_.isNil(r)) {
      if (!_.isNil(s))
        return s;
      return getEmptyDashboard();
    }
    return r;
  }

  get enabledDashboards(): IDashboard[] {
    return this.availableDashboards.filter(d => d.isEnabled);
  }

  get defaultDashboard(): IDashboard | null {
    const dd = this.enabledDashboards.filter(d => d.isDefault);
    if (dd.length)
      return dd[0];
    return null;
  }

  get defaulDashboardId(): string | null {
    const defaultDashboard = this.defaultDashboard;
    if (_.isNil(defaultDashboard))
      return null;
    return defaultDashboard.id;
  }

  get areDashboardsAvailable() {
    return this.availableDashboards.length > 0;
  }

  get areSharedDashboardsAvailable() {
    return this.sharedWithMeDashboards.length > 0;
  }

  get areEnabledDashboardsAvailable() {
    return this.enabledDashboards.length > 0;
  }

  get showDashboardAdd() {
    return !(this.areEnabledDashboardsAvailable || this.areSharedDashboardsAvailable) || this.internalShowDashboardAdd;
  }
  get showDashboardEdit() {
    return this.internalShowDashboardEdit;
  }

  get showDashboardGrid() {
    return (this.areEnabledDashboardsAvailable || this.areSharedDashboardsAvailable) && this.internalShowGrid && !(this.internalShowDashboardEdit || this.internalShowDashboardAdd);
  }

  get dashboardSelectCloseButtonProps() {
    return {
      location: 'after',
      options: {
        class: 'mr-2',
        icon: 'far fa-times',
        onClick: this.onDashboardSelectCloseClick,
        stylingMode: 'outlined',
        text: this.$t('dashboard.close'),
      },
      toolbar: 'bottom',
      widget: 'dxButton'
    };
  }

  get addEditDashboardClasses() {
    return {
      'mx-2': true,
      'w-50': this.$screen.breakpoint !== 'xs' && this.$screen.breakpoint !== 'sm',
      'w-100': this.$screen.breakpoint === 'xs' || this.$screen.breakpoint === 'sm'
    };
  }

  async loadDashboardList() {
    this.isLoadingDashboardsList = true;
    let dashboardId = this.currentDashboardId;
    this.availableDashboards = await apiService.post('dashboards', 'selection', { idCustomer: customerService.getCustomer() });
    this.availableCompanies = await apiService.post<ICompanyItem[]>('company', 'companiesByCustomer', { idCustomer: customerService.getCustomer() }, {
      axiosConfig: {
        baseURL: configuration.authBackendBaseUrl
      }
    });

    this.sharedWithMeDashboards = await apiService.post('dashboards', 'sharedSelection', { idCustomer: customerService.getCustomer(), companies: this.availableCompanies },);

    //filter out duplicates dashboards that can be present after sharing between client or company
    this.sharedWithMeDashboards = this.sharedWithMeDashboards.filter(d => !this.availableDashboards.some(a_d => d.id === a_d.id));

    this.dashboardLastSelectedId = await apiService.post('dashboards', 'lastSelection', { idCustomer: customerService.getCustomer() });

    const enabledDashboards = this.enabledDashboards;
    if (_.isNil(dashboardId)) {
      const defaultDashboard = this.defaultDashboard;
      if (!_.isNil(defaultDashboard))
        dashboardId = defaultDashboard.id;
      else if (enabledDashboards.length)
      {
        if (!_.isNil(this.dashboardLastSelectedId))
            dashboardId = this.dashboardLastSelectedId;
          else
            dashboardId = enabledDashboards[0].id;
      }
      else if (this.areSharedDashboardsAvailable)
        dashboardId = this.sharedWithMeDashboards.filter(x => x.isEnabled == true)[0].id;
      else
        dashboardId = null;
    }
    else if (!this.currentDashboard.isEnabled) {
      if (enabledDashboards.length)
        dashboardId = enabledDashboards[0].id;
      else
        dashboardId = null;
    }
    if (dashboardId !== this.currentDashboardId)
      this.currentDashboardId = dashboardId;

    this.isLoadingDashboardsList = false;
  }

  isDashboardEnabled(idDashboard: string) {
    return this.enabledDashboards.some(d => d.id === idDashboard);
  }
  isDashboardShared(idDashboard: string) {
    return this.sharedWithMeDashboards.some(d => d.id === idDashboard);
  }

  sharedDashboard(b: boolean) {
    this.currentDasboardShared = b;
  }

  onChartShareClick({ idChart }) {
    this.idChartToShare = idChart;
    this.showChartSharingPanel = true;
  }

  async onChartDeleteClick({ idChart }) {
    this.confirmDialog(this.$t('chart.delete.warning'), async () => {
      await apiService.post('charts', `${idChart}/${this.currentDashboardId}/deleteChartFromDashboard`);
      this.reloadDashboard();
    });
  }

  onChartEditClick({ idChart }) {
    this.$router.push({
      name: 'charts.create.multiple',
      query: {
        idChart: idChart,
        idDashboard: this.currentDashboardId
      }
    });
  }

  changeArrowPosition(elementPos: string) {
    if (elementPos === 'left') {
      this.setLeftProp('23%');
    }
    if (elementPos === 'right') {
      this.setLeftProp('83%');
    }
  }

  setLeftProp(left: string) {
    const root = document.querySelector(':root') as HTMLStyleElement;
    root.style.setProperty('--pos-left', left);
  }

  onDashboardShareClick() {
    this.dashboardToShareId = this.currentDashboardId;
    this.showDashboardSharingPanel = true;
    this.closeTooltip();
  }

  onDashboardNameClick(dashboard: { id: string }) {
    this.showDashboardSelectionPanel = false;
    if (this.isDashboardEnabled(dashboard.id))
      this.currentDashboardId = dashboard.id;
    if (this.isDashboardShared(dashboard.id)) {
      this.currentDashboardId = dashboard.id;
    }
  }
  onDashboardSelectEditClick(dashboard: { id: string }) {
    this.showDashboardSelectionPanel = false;
    this.currentDashboardId = dashboard.id;
    this.internalShowDashboardEdit = true;
  }
  onDashboardselectionShareClick(dashboard: { id: string }) {
    this.dashboardToShareId = dashboard.id;
    this.showDashboardSharingPanel = true;
  }
  async onDashboardSelectEnable(dashboard: { id: string }) {
    await apiService.post('dashboards', `${dashboard.id}/enable`);
    await this.loadDashboardList();
  }
  async onDashboardSelectDisable(dashboard: { id: string }) {
    this.confirmDialog(this.$t('dashboard.disable.warning'), async () => {
      await apiService.post('dashboards', `${dashboard.id}/disable`);
      await this.loadDashboardList();
    });
  }

  onDashboardSelectCloseClick() {
    this.showDashboardSelectionPanel = false;
  }


  onShowChartsList() {
    this.showChartsListPanel = true;
    this.closeTooltip();

  }

  onAddChartClick() {
    this.$router.push({
      name: 'charts.create.multiple',
      query: {
        idDashboard: this.currentDashboardId
      }
    });
    this.closeTooltip();
  }
  addTooltip(target: string, text: string) {
    this.tooltipTarget = target;
    this.tooltipText = text;
    this.showTooltip = true;
    this.setLeftProp('50%');
  }

  closeTooltip() {
    this.showTooltip = false;
  }
  onDashboardAddClick() {
    // this.showAddDashboardPopup = true;
    this.internalShowDashboardEdit = false;
    this.internalShowDashboardAdd = !this.internalShowDashboardAdd;
    this.closeTooltip();

  }

  onDashboardEditClick() {
    this.internalShowDashboardAdd = false;
    this.internalShowDashboardEdit = !this.internalShowDashboardEdit;
    this.closeTooltip();
    // this.showEditDashboardPopup = true;
  }

  onDashboardSelectClick() {
    this.showDashboardSelectionPanel = true;
    this.closeTooltip();
  }

  async onChartAdded() {
    await this.reloadDashboard();
  }

  async onRefreshClick() {
    this.closeTooltip();
    await this.reloadDashboard();
  }

  async onAddDashboard(eventData: { idDashboard: string }) {

    await this.loadDashboardList();
    this.currentDashboardId = eventData.idDashboard;
    this.internalShowDashboardAdd = false;
    this.sharedDashboard(false);
    this.onAddDashboardClose();
  }

  onAddDashboardClose() {
    this.internalShowDashboardAdd = false;
  }

  async onUpdateDashboard() {
    await this.loadDashboardList();
    this.internalShowDashboardAdd = false;
  }

  onUpdateDashboardClose() {
    this.internalShowDashboardEdit = false;
  }

  @Watch('idCustomer')
  onCustomerChange() {
    this.currentDashboardId = null;
    this.loadDashboardList();
  }
}

interface ICompanyItem {
  Id: string;
  BusinessName: string;
}
